import React from 'react';
import { cx } from '@/ui/utils/cx';

export type AppButtonVariant =
  | 'primary'
  | 'secondary'
  | 'ghost'
  | 'danger'
  | 'warning'
  | 'success'
  | 'subtle';

export type AppButtonSize = 'sm' | 'md' | 'lg';

export type AppButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: AppButtonVariant;
  size?: AppButtonSize;
  loading?: boolean;
  block?: boolean;
};

const AppButton = React.forwardRef<HTMLButtonElement, AppButtonProps>(function AppButton(
  {
    variant = 'secondary',
    size = 'md',
    loading = false,
    block = false,
    className,
    children,
    disabled,
    type = 'button',
    ...rest
  },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cx(
        'app-btn',
        `app-btn--${variant}`,
        size !== 'md' && `app-btn--${size}`,
        block && 'app-btn--block',
        loading && 'app-btn--loading',
        className,
      )}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <span className="spinner app-btn__spinner" aria-hidden /> : null}
      {children}
    </button>
  );
});

export default AppButton;
